import { toOperationTimestamp } from '@/components/organisms/FishGroupForms';
import { now as currentInstant } from '@/utils/date';

import { earliestStartDate } from '../../components/NewFishGroupModal/startDateLimit';

function localDay(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

/**
 * The first day an event can be registered on: no earlier than a new group's start may be
 * (one month back, D21), and not before the group came into the pen(s) it acts on.
 */
export function earliestEventDay(notBefore: Date | null, reference: Date = currentInstant()): Date {
    const window = earliestStartDate(reference);
    if (!notBefore) return window;
    const stayDay = localDay(notBefore);
    return stayDay.getTime() > window.getTime() ? stayDay : window;
}

/** A picked day before `earliest`, compared as local calendar days. */
export function isBeforeDay(picked: Date, earliest: Date): boolean {
    return localDay(picked).getTime() < localDay(earliest).getTime();
}

/** A picked day after today. */
export function isFutureDay(picked: Date, reference: Date = currentInstant()): boolean {
    return localDay(picked).getTime() > localDay(reference).getTime();
}

/** The instant sent for a picked day: now for today, noon otherwise, after `notBefore`. */
export function eventTimestamp(picked: Date, notBefore: Date | null): string {
    return toOperationTimestamp(picked, { notBefore });
}

/** The latest start among the stays an operation closes: its date must come after all of them. */
export function latestStart(dates: (Date | null | undefined)[]): Date | null {
    return dates.reduce<Date | null>(
        (latest, date) => (date && (!latest || date > latest) ? date : latest),
        null
    );
}
